import { Tag, TagLabel, Flex, Badge } from "@chakra-ui/react";

interface GreenRedTagProps {
  isTrue: boolean;
  isTrueText: string;
  isFalseText: string;
}

export default function GreenRedTag({
  isTrue,
  isTrueText,
  isFalseText,
}: GreenRedTagProps) {
  return (
    <Tag size="sm" variant="outline" colorScheme="gray" boxShadow="inset 0 0 0px .5px" color="content.tertiary">
      <TagLabel>
        <Flex align="center" gap="1">
          <Badge
            boxShadow="none"
            variant="solid"
            colorScheme={isTrue ? "green" : "red"}
            borderRadius="8px"
            size="xs"
            minWidth="8px"
            minHeight="8px"
          />
          {isTrue ? isTrueText : isFalseText}
        </Flex>
      </TagLabel>
    </Tag>
  );
}
